import { Portal } from '@reach/portal';
import cl from 'classnames';
import * as React from 'react';
import { Range, Transforms } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';
import styled from 'styled-components';

import { isSelectionExpanded } from '../../../../slatePlugins';
import { BalloonToolbarProps } from '../../../../slatePlugins/components/Toolbar/BalloonToolbar/BalloonToolbar.types';
import { setPositionAtSelection } from '../../../../slatePlugins/components/Toolbar/BalloonToolbar/setPositionAtSelection';
import { useBalloonMove } from '../../../../slatePlugins/components/Toolbar/BalloonToolbar/useBalloonMove';
import { PreventHiddenToolbarProps, withPreventHiddenToolbar } from '../prevent-toolbar-hidden/withPreventHiddenToolbar';
import { StyledToolbar } from '../StyledToolbar';
import { BalloonToolbarOnExpandedContext } from './BalloonToolbarOnExpandedContext';

interface BalloonToolbarOnExpandedProps extends BalloonToolbarProps, PreventHiddenToolbarProps {}

export const BallonToolbarMain = styled.div`
  display: block;
  &.hidden {
    display: none;
  }
`;

const BalloonToolbarOnExpandedBase = (props: BalloonToolbarOnExpandedProps) => {
  const {
    className,
    children,
    direction = 'top',
    theme = 'dark',
    arrow = false,
    preventToolbarHidden,
  } = props;

  const [hidden, setHidden] = React.useState(true);

  const ref = React.useRef<HTMLDivElement>(null);
  const editor = useSlate();
  const selectionExpanded = editor && isSelectionExpanded(editor);

  const reSelectText = React.useCallback(
    async (selectionRange: Range) => {
      // Skip reselect if selected
      if (editor.selection) return;

      // Focus Editor and reselect text
      await ReactEditor.focus(editor as any);
      await Transforms.select(editor, selectionRange);

      // set toolbar position at selection after reselect
      setPositionAtSelection(ref.current, 'bottom');
    },
    [editor, ref]
  );

  // const { isClickCurrentElement } = useOutsideClick(ref);

  React.useEffect(() => {
    setHidden(
      !(
        ((ref.current && selectionExpanded) || preventToolbarHidden)
        // isClickCurrentElement
      )
    );
  }, [preventToolbarHidden, selectionExpanded]);
  useBalloonMove({ editor, ref, direction });

  return (
    <BalloonToolbarOnExpandedContext.Provider
      value={{
        reSelectText,
      }}
    >
      <Portal>
        <BallonToolbarMain className={cl({ hidden })}>
          <StyledToolbar
            ref={ref}
            className={cl(className, 'dol-balloon-toolbar')}
            $hidden={hidden}
            $theme={theme}
            $arrow={arrow}
          >
            {children}
          </StyledToolbar>
        </BallonToolbarMain>
      </Portal>
    </BalloonToolbarOnExpandedContext.Provider>
  );
};

export const BalloonToolbarOnExpanded = withPreventHiddenToolbar(BalloonToolbarOnExpandedBase);
